import { Injectable } from '@angular/core';
import { InboxInvoices } from 'src/app/modules/bookkeeping/models/invoice/inbox-invoices';
import { HttpParameterCodec, HttpParams } from '@angular/common/http';
import { HeaderSearchParams, HeaderSearchResponse } from '../model/search-result';
import { HttpInternalService } from './http.service';

/**
 * Angular's default codec leaves "+" bare, which the server reads as a space -- so "+61 400"
 * or "C++" would be searched wrongly. Encode every value fully.
 */
class StrictParameterCodec implements HttpParameterCodec {
  encodeKey(key: string): string { return encodeURIComponent(key); }
  encodeValue(value: string): string { return encodeURIComponent(value); }
  decodeKey(key: string): string { return decodeURIComponent(key); }
  decodeValue(value: string): string { return decodeURIComponent(value); }
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  constructor(
    private _httpService: HttpInternalService,
  ) { }

  searchInvoices(filterParams: string) {
    return this._httpService.getRequest<InboxInvoices>(`Search/searchInvoices${filterParams}`);
  }

  searchSuppliers(filterParams: string) {
    return this._httpService.getRequest<any>(`Search/searchSuppliers${filterParams}`);
  }

  /**
   * SD-1245: the header search. The server ranks the results and narrows them to what the user
   * may see; the query goes as a real query parameter, so "AT&T" or "#1042" arrive intact.
   */
  headerSearch(params: HeaderSearchParams) {
    let httpParams = new HttpParams({ encoder: new StrictParameterCodec() })
      .set('organizationId', params.organizationId)
      .set('q', params.q);
    if (params.types && params.types.length) {
      httpParams = httpParams.set('types', params.types.join(','));
    }
    if (params.take) {
      httpParams = httpParams.set('take', String(params.take));
    }
    return this._httpService.getRequest<HeaderSearchResponse>('Search/global', httpParams);
  }
}
